import { render, staticRenderFns } from "./ImagenUsuario.vue?vue&type=template&id=135b2f7c&scoped=true&"
import script from "./ImagenUsuario.vue?vue&type=script&lang=js&"
export * from "./ImagenUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135b2f7c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/ImagenUsuario.vue
// module id = 623
// module chunks = 3